const event_transactions = {
  id: 'Id',
  ambassador_id: 'Ambassador ID',
  title: 'Title',
  donor_name_displayed: 'Donor Name',
  is_anonymous: 'Anonymous',
  amount_multiplier: 'Amount Multiplier',
  donor_comment: 'Donor Comment',
  source_reference: 'Source Reference',
  source_reference_url: 'Source Reference URL',
  show_pledge: 'Show Pledge',
  pledge_date: 'Pledge Date',
  contact_id: 'Contact ID',
  invoice_id: 'Invoice ID',
  payment_id: 'Payment ID',
};

export default event_transactions;
